import useSearchParam from "./useSearchParam"
import SideTrayMenu from "./components/SideTrayMenu"
import styled from "styled-components"

import { Link } from "react-router-dom"
const Column = styled.div`
  padding-top: 100px;
  padding-bottom: 30px;
`
/**
 *
 * @param {*} param0
 */
const TrayDesignerApp = ({ children }) => {
  const trayVariant = useSearchParam("trayVariant")
  return (
    <div className="row">
      <Column
        className="col-md-2 col-sm-3"
        style={{ paddingLeft: 30, paddingRight: 30, paddingTop: 100 }}
      >
        <Link to="/" style={{ textDecoration: "none", color: "black" }}>
          <img
            loading="lazy"
            src="/assets/logo.png"
            alt="Cambro logo"
            width="100%"
            className="img-responsive"
          />
          <br />
          <br />
          <h2 className="heading text-capitalize">tray decorator</h2>
          <br />
          <h3>Choose a tray shape below</h3>
        </Link>
        <div>{trayVariant !== null && <SideTrayMenu />}</div>
      </Column>
      <Column className="col-md-10 col-sm-9 designer-block">{children}</Column>
    </div>
  )
}

export default TrayDesignerApp
